import { createSelector } from '@reduxjs/toolkit';

import { selectEntities } from '@/services/selectors';

export const selectSecretsEntities = createSelector(selectEntities, entities => entities.secrets);

export const selectSecretsNotes = createSelector(selectSecretsEntities, ({ searchIndex }) => searchIndex);
